import React, {useState, useEffect,forwardRef, useImperativeHandle} from 'react';
import ScrollView from 'devextreme-react/scroll-view';
import StatesService from '../../../utils/states';
import CountryService from '../../../utils/country';
import Form, {Item,SimpleItem, RequiredRule, EmptyItem} from 'devextreme-react/form';
import shipmentApi from '../../../api/shipment';
import AddressApi from '../../../api/address';
import AccShipping from '../shipments-config/acc-shipping';
import OrderApi from '../../../api/order';
import DataSource from 'devextreme/data/data_source';
import { useHistory, useLocation  } from 'react-router-dom';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import sessions from '../../../sessions';
import './index.scss';


const OrderDetailsEdit = forwardRef(({data},ref) => {
    var sku =  data.sku;
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const [countryValue, setCountryValue] = useState('');
    const [orderData,setOrderData] =  useState(data);
    const [SKU, setSKU] = useState();
    const [isloadPanelVisible, setIsloadPanelVisible] = useState(false);
    const [isValidatePanelVisible, setIsValidatePanelVisible] = useState(false);  
    const position = { of: '#ebay-form-content' };
    const validatePosition = { my: 'right', at: 'center'};
    const history = useHistory();
    const location = useLocation();
    const validateAddressOnClick = async() => {
        setIsValidatePanelVisible(true);
        await shipmentApi.validateAddress(userId,orderData,auth).then(result=>{
            if(result.status === 200){
                notify("address corrected", "success", 500);
                setOrderData(result.data.data);
                setIsValidatePanelVisible(false);
            }
            else if(result.status === 202){
                notify("address validated", "success", 500);
                setOrderData(result.data.data);
                setIsValidatePanelVisible(false);  
            }
        }).catch(err => {
            if(err.message.includes("400"))
                notify("zip code only can contain 5 digit", "error", 500);
            else if(err.message.includes("401"))
                notify("failed to validate address.", "error", 500);
            else if(err.message.includes("402"))
                notify("cant validate country other than US", "error", 500);
            setIsValidatePanelVisible(false);
        });
    }

    const currencyFormat = () => {
        var curr = orderData?.currency? AddressApi.getSymbolbyCurrencyName(orderData.currency):AddressApi.getSymbolbyCurrencyName("USD");
        return `${curr} #,##0.##;(${curr} #,##0.##)`
    }
    
    const country = new DataSource({
        store: {
            type: 'array',
            data: CountryService,
            key: 'iso2'
        },
        pageSize: 10,
        paginate: true
    });
    const CountryOnChange = ({value}) => {
        setCountryValue(value);
        //console.log(countryValue);
    }

    const state = new DataSource({
        store: {
            data: StatesService,
            type: 'array',
            key: 'name'
        },
        filter: [
            "country_code", "=", countryValue
        ],
        pageSize: 10,
        paginate: true
    });

    useEffect(()=>{
        setSKU(sku);
        setOrderData(data);
    },[data]);

    const saveOnClick = (e) => {
        const res = e.validationGroup.validate(); 
        //console.log(res);
        onSubmit(e);
    }
    const onSubmit = async(e) => {
        e.event.preventDefault();
        var payload = orderData;
        payload.sku = SKU;
       //console.log(payload);
       try{
        await OrderApi.updateOrderById(payload._id,payload,auth).then(result =>{
            setIsloadPanelVisible(false);
            notify(result.data.message ,"success", 500);
            e.validationGroup.reset();  
            history.replace(location.pathname);
       });
       }catch(err){
            console.log(err);
            notify("Error", "error", 500);
            setIsloadPanelVisible(false);
       }
    }

    const gridDataOnIserted = (e) =>{
        //console.log(e.data);
        setSKU(e.data);
    }

    useImperativeHandle(ref, (e) => ({saveOnClick}));

    return (
        <React.Fragment>
            <ScrollView>
                <div className="detail-view flex flex-row">
                    <div className={'detail-information'}>
                        <div className={'detail-order'}>
                            <div className={'title'}>Order Information</div>
                            <Form formData={orderData} colCount={3} validationGroup='group'>
                                <SimpleItem dataField={'orderNo'} editorOptions={{stylingMode: 'outlined', readOnly:true}}/>
                                <SimpleItem dataField={'status'} editorOptions={{ stylingMode: 'outlined', readOnly:true}}/>
                            </Form>
                        </div>
                        <div className={'detail-recipient'}>
                            <div  className={'title'}>Customer Information</div>
                            <form onSubmit={onSubmit}>
                            <Form  id={'customer-data'} formData={orderData} colCount={3} validationGroup='group'>
                                <SimpleItem dataField={'name'} editorOptions={{ }}>
                                    <RequiredRule message="name is required"/>
                                </SimpleItem>
                                <SimpleItem dataField={'email'} editorOptions={{ }}/>
                                <SimpleItem dataField={'phone'} editorOptions={{}}/>
                                <SimpleItem dataField={'addressLine1'} colSpan={3} editorOptions={{ }}>
                                    <RequiredRule message="addressLine1 is required"/>
                                </SimpleItem>
                                <SimpleItem dataField={'city'} editorOptions={{ }}/>
                                <Item
                                    dataField="state"
                                    editorType="dxSelectBox"
                                    editorOptions={{
                                    dataSource: state,
                                    searchEnabled: true,
                                    displayExpr: 'name',
                                    valueExpr: 'name'
                                }}>
                                <RequiredRule message="state is required"/>
                                </Item>
                                 <Item
                                    editorType={'dxSelectBox'}
                                    dataField="country"
                                    editorOptions={{
                                    dataSource: country,
                                    searchEnabled: true,
                                    displayExpr: 'name',
                                    valueExpr: 'iso2',
                                    onValueChanged: CountryOnChange
                                }}>
                                <RequiredRule message="country is required"/>
                                </Item>
                                <SimpleItem dataField={'zipCode'} editorOptions={{ }}>
                                    <RequiredRule message="zipcode is required"/>
                                </SimpleItem>
                                <SimpleItem itemType="button"
                                    horizontalAlignment="left"
                                    cssClass="validate-address-btn"
                                    buttonOptions={{
                                        type:'success',
                                        icon:'fas fa-check',
                                        text: 'validate',
                                        hint: 'validate address',
                                        onClick:validateAddressOnClick
                                    }}>
                                </SimpleItem>
                                <EmptyItem/>
                                <Item
                                    editorType={'dxNumberBox'}
                                    dataField="shippingPaid"
                                    editorOptions={{
                                    format: currencyFormat
                                }}/>
                                <Item
                                    editorType={'dxNumberBox'}
                                    dataField="taxPaid"
                                    editorOptions={{
                                    format: currencyFormat
                                }}/>
                                <Item
                                    editorType={'dxNumberBox'}
                                    dataField="totalPaid"
                                    editorOptions={{
                                    format: currencyFormat
                                }}/>
                            </Form>
                            </form>
                        </div>
                        <div className={'detail-recipient'}>
                            <div className={'title'}>Item Information</div>
                            <Form formData={SKU} validationGroup='group'>
                            <Item editorType="dxDataGrid" 
                                    editorOptions={{
                                        dataSource:SKU,
                                        columns:[
                                            {
                                                dataField: "sku",
                                                datatype:"string"
                                            },
                                            {
                                                dataField: "name",
                                                datatype:"string"
                                            },
                                            {
                                                dataField: "quantity",
                                                datatype:"number"
                                            },
                                            {
                                                dataField: "price",
                                                alignment:"right"
                                            }
                                        ],
                                        onRowInserted: {gridDataOnIserted},
                                        editing:{
                                            mode:'cell',
                                            allowAdding:true,
                                            allowUpdating:true,
                                            allowDeleting:true,
                                            confirmDelete:false
                                        }
                                    }}
                                />
                            </Form>
                        </div>
                    </div>
                    <div className={'detail-shipments'}>
                        <AccShipping data={data}/>
                    </div>
                    <LoadPanel
                        position={position}
                        onHiding={!isloadPanelVisible}
                        visible={isloadPanelVisible}
                        showIndicator={true}
                        shading={false}
                        showPane={false}
                        closeOnOutsideClick={false}/>
                    <LoadPanel
                        position={validatePosition}
                        onHiding={!isValidatePanelVisible}
                        visible={isValidatePanelVisible}
                        showIndicator={true}
                        shading={false}
                        showPane={true}
                        closeOnOutsideClick={false}/>
                </div>
            </ScrollView>
        </React.Fragment>

    );
});

export default OrderDetailsEdit;